import type { SerializedStyles, Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { breakpoint } from '@twistopayments/design-system/styles'

import type { Align } from './headline'

export const container = css`
  display: grid;
  position: relative;
  grid-auto-flow: row;
  grid-auto-rows: max-content;
`

export const align: Record<Align, SerializedStyles> = {
  start: css`
    justify-items: start;
    text-align: start;
  `,
  center: css`
    justify-items: center;
    text-align: center;
  `,
}

export const goBack = (theme: Theme) => css`
  margin-bottom: ${theme.spacing[32]};
`

export const topMargin = (theme: Theme) => css`
  margin-top: ${theme.spacing[104]};

  ${breakpoint.up('sm')} {
    margin-top: 0;
  }
  ${breakpoint.down('sm')} {
    margin-top: ${theme.spacing[24]};
  }
`

export const fullWidth = css`
  width: 100%;
`
